import { styled } from 'linaria/react';
import { css } from 'linaria';

export const LabelsContainerWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	width: 100%;
	margin-bottom: 31px;
	column-gap: 16px;
	row-gap: 12px;
`;

// эти стили прописаны для того, чтобы изменить фронтоновские стили, которые идут по умолчанию
// позволяют выводить в лейбл полное название услуги, а не обрезанное многоточием
export const ChipStyle = css`
	max-width: max-content !important;

	& > span > div > div {
		max-width: initial !important;
	}
`;

// эти стили прописаны для того, чтобы изменить фронтоновские стили, которые идут по умолчанию
export const ClearAllChipStyles = css`
	& > span > div {
		max-width: max-content;
		margin-right: 0;
	}

	& > span > div + div {
		display: none;
	}
`;
